module.exports = __webpack_public_path__ + "img/review-us-on-linkedIn.f895cd3b.jpg";